import { useTheme } from '../../context/ThemeContext';

// Icons
const BellIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const MegaphoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m3 11 18-5v12L3 14v-3z" />
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
  </svg>
);

const TargetIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const UsersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const LocationNotifications = () => {
  const { theme } = useTheme();

  const features = [
    {
      icon: <CalendarIcon />,
      title: 'Trade Night Alerts',
      description: 'Auto-notify followers about upcoming trade nights and events',
      color: '#3b82f6',
    },
    {
      icon: <MegaphoneIcon />,
      title: 'Manual Broadcasts',
      description: 'Send custom announcements to your followers',
      color: '#f59e0b',
    },
    {
      icon: <TargetIcon />,
      title: 'Targeted Notifications',
      description: 'Reach traders by distance, activity, or preferences',
      color: '#22c55e',
    },
    {
      icon: <SettingsIcon />,
      title: 'Notification Settings',
      description: 'Control frequency, timing, and types of alerts',
      color: '#8b5cf6',
    },
    {
      icon: <UsersIcon />,
      title: 'Follower Insights',
      description: 'See who follows your shop and engagement stats',
      color: '#ec4899',
    },
  ];

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={{ ...styles.header, backgroundColor: theme.bgSheet, borderColor: theme.border }}>
        <div style={{ ...styles.iconContainer, backgroundColor: 'rgba(59, 130, 246, 0.15)' }}>
          <BellIcon />
        </div>
        <div style={styles.headerText}>
          <h2 style={{ ...styles.title, color: theme.text }}>Notifications</h2>
          <p style={{ ...styles.subtitle, color: theme.textSecondary }}>
            Manage alerts and reach your traders
          </p>
        </div>
      </div>

      {/* Coming Soon Banner */}
      <div style={{ ...styles.comingSoonBanner, backgroundColor: 'rgba(59, 130, 246, 0.1)', borderColor: 'rgba(59, 130, 246, 0.3)' }}>
        <span style={{ ...styles.comingSoonText, color: '#3b82f6' }}>Coming Soon</span>
        <p style={{ ...styles.comingSoonDesc, color: theme.textSecondary }}>
          Notification management is being developed!
        </p>
      </div>

      {/* Feature List */}
      <div style={styles.featureList}>
        <h3 style={{ ...styles.sectionTitle, color: theme.text }}>Planned Features</h3>

        {features.map((feature, index) => (
          <div
            key={index}
            style={{
              ...styles.featureCard,
              backgroundColor: theme.bgSheet,
              borderColor: theme.border,
              opacity: 0.7,
            }}
          >
            <div style={{ ...styles.featureIcon, backgroundColor: `${feature.color}20`, color: feature.color }}>
              {feature.icon}
            </div>
            <div style={styles.featureContent}>
              <span style={{ ...styles.featureTitle, color: theme.text }}>{feature.title}</span>
              <span style={{ ...styles.featureDesc, color: theme.textSecondary }}>{feature.description}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Info Box */}
      <div style={{ ...styles.infoBox, backgroundColor: theme.bgSheet, borderColor: theme.border }}>
        <p style={{ ...styles.infoText, color: theme.textSecondary }}>
          Notifications help you stay connected with your trading community.
          You'll be able to announce trade nights, special events, and keep
          traders engaged with your shop.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: 16,
    paddingBottom: 120,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: 20,
    borderRadius: 16,
    border: '1px solid',
    marginBottom: 16,
  },
  iconContainer: {
    width: 64,
    height: 64,
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#3b82f6',
  },
  headerText: {
    flex: 1,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    margin: '4px 0 0 0',
  },
  comingSoonBanner: {
    padding: 16,
    borderRadius: 12,
    border: '1px solid',
    marginBottom: 20,
    textAlign: 'center',
  },
  comingSoonText: {
    fontSize: 14,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  comingSoonDesc: {
    fontSize: 13,
    margin: '8px 0 0 0',
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 600,
    margin: '0 0 12px 0',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  featureList: {
    marginBottom: 20,
  },
  featureCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    padding: 14,
    borderRadius: 12,
    border: '1px solid',
    marginBottom: 8,
  },
  featureIcon: {
    width: 44,
    height: 44,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  featureContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  featureTitle: {
    fontSize: 14,
    fontWeight: 600,
  },
  featureDesc: {
    fontSize: 12,
  },
  infoBox: {
    padding: 16,
    borderRadius: 12,
    border: '1px solid',
  },
  infoText: {
    fontSize: 13,
    lineHeight: 1.5,
    margin: 0,
  },
};

export default LocationNotifications;
